export function getValueOrFallback(
  questionDetails: string | undefined | null,
  fallback: string,
) {
  if (!questionDetails) {
    return fallback;
  }

  return questionDetails.length > 0 ? questionDetails : fallback;
}
